// extracted by mini-css-extract-plugin
export default {"title":"Products_title__SxrG1","description":"Products_description__Ns61K","card":"Products_card__is4zK"};